

exports.__esModule = true;
exports.$TravelRuleRoute = undefined;

require('./directive');

var _squid = require('squid');

var $TravelRuleRoute = exports.$TravelRuleRoute = _squid.$ComponentRoute.extend('$TravelRuleRoute', {

    path: 'travelRule',
    directive: 'xo-travel-rule-page',
    titleContent: 'travelRule.travelRule',
    trackingData: {
        templateName: 'travelRule.dust',
        pageGoal: 'collect payer ssn and/or taxId',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-travel-rule',
                'pagename2': '%::fullpage-travel-rule:member:hermes:',
                'version': 'member:%:'
            }
            // More page qualifiers come here...
        }
    },
    loginRequired: true,
    children: []
});

angular.value("$TravelRuleRoute", $TravelRuleRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-travel-rule/route.js
// module id = ./pages/xo-travel-rule/route.js
// module chunks = 1